import { Navigate } from "react-router";

import { useSession } from "@/hooks/use-session";

export const AuthRoute = ({ children }: { children: React.ReactNode }) => {
  const { session } = useSession();

  if (!session) {
    return <Navigate replace to="/" />;
  }

  return children;
};
